var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMergeHorizontal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM15.1953 6.84483L12.3619 9.81983C12.1649 10.0267 11.8348 10.0267 11.6378 9.81983L8.80445 6.84483C8.50128 6.5265 8.72692 6 9.16652 6H14.8332C15.2728 6 15.4984 6.5265 15.1953 6.84483ZM15.1953 17.1552C15.4984 17.4735 15.2728 18 14.8332 18H9.16652C8.72692 18 8.50128 17.4735 8.80445 17.1552L11.6378 14.1802C11.8348 13.9733 12.1649 13.9733 12.3619 14.1802L15.1953 17.1552ZM7.82129 12C7.82129 11.5858 8.15708 11.25 8.57129 11.25H15.4284C15.8426 11.25 16.1784 11.5858 16.1784 12C16.1784 12.4142 15.8426 12.75 15.4284 12.75H8.57129C8.15708 12.75 7.82129 12.4142 7.82129 12Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMergeHorizontal);
export default __webpack_public_path__ + "static/media/merge-horizontal.dec40a9cc1aac6cca42b5a2fe22f5611.svg";
export { ForwardRef as ReactComponent };